<template>
  <f7-page class="no-swipeback" login-screen @page:reinit id="login" >
    <div class="body">
      <b-row class="h-100">
        <div class="position-absolute welcome-text-login">
          <h1 class="d-block text-center text-white" style="font-size:3rem !important">
            {{ $t('Homepage.connect_toolbox') }}
          </h1>
        </div>
        <div class="loginPanel loginHeight">
          <div>
            <b-row class="panel-heading ajust text-center mb-2rem">
              <b-col cols="2"></b-col>
              <b-col cols="8" class="p-2">
                <span class="navbar-brand mr-0 w-80">
                  <img :src="imgVarsLong" alt="DealPrudence" class="heritage largescreen w-100">
                  <!--<img :src="imgVarsShort" @click="loadAccueil" alt="VOP" class="heritage middlescreen">-->
                </span>
              </b-col>
              <b-col cols="2" class="p-0">
                <b-dropdown left class="no-back" toggle-class="border-0 m-md-2 z-5" variant="light" v-model="language" v-if="!flagTOOLBOX">
                  <template slot="button-content">
                    <img class="flag-nav" v-if="language === 'FR'" :src="logoFlagFR" alt=""/>
                    <img class="flag-nav" v-if="language === 'EN'" :src="logoFlagEN" alt=""/>
                    <img class="flag-nav" v-if="language === 'GB'" :src="logoFlagEN" alt=""/>
                    <img class="flag-nav" v-if="language === 'DE'" :src="logoFlagDE" alt=""/>
                    <img class="flag-nav" v-if="language === 'IT'" :src="logoFlagIT" alt=""/>
                    <img class="flag-nav" v-if="language === 'ES'" :src="logoFlagES" alt=""/>
                    <img class="flag-nav" v-if="language === 'PT'" :src="logoFlagPT" alt=""/><span class="">{{ labelLanguage }}</span>
                  </template>
                  <b-dropdown-item v-for="option in langOptions" :key="option.value" class="dropdown-item-web-header" @click="languageCountry(option.value)">
                    <img class="flag-nav" v-if="option.value === 'FR'" :src="logoFlagFR" alt=""/>
                    <img class="flag-nav" v-else-if="option.value === 'GB'" :src="logoFlagEN" alt=""/>
                    <img class="flag-nav" v-else-if="option.value === 'DE'" :src="logoFlagDE" alt=""/>
                    <img class="flag-nav" v-else-if="option.value === 'IT'" :src="logoFlagIT" alt=""/>
                    <img class="flag-nav" v-else-if="option.value === 'ES'" :src="logoFlagES" alt=""/>
                    <img class="flag-nav" v-else-if="option.value === 'PT'" :src="logoFlagPT" alt=""/>
                    <img class="flag-nav" v-else :src="logoFlagEN" alt=""/>
                    <span>{{option.text}}</span>
                  </b-dropdown-item>
                </b-dropdown>
              </b-col>
            </b-row>
            <div @keyup.enter="registerUser()" v-if="mode === 'confirmEmail'">
              <b-row>
                <b-col cols="8" offset="2" class="form-group">
                  <form-write-group-label-input v-model="credentials.Login" id="Login"
                    inputType="text"
                    :inputLabel="$t('common.eml_adrs')"
                    inputClass="inputLogin"
                    :specificErrorIndicator="credentials.LoginError"
                    :specificMessage="credentials.LoginErrorMessage">
                  </form-write-group-label-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="8" offset="2" class="form-group">
                  <form-write-group-label-input v-model="credentials.Token" id="Token"
                    inputType="text"
                    :inputLabel="$t('common.login_token')"
                    inputClass="inputLogin"
                    :specificErrorIndicator="credentials.TokenError"
                    :specificMessage="credentials.TokenErrorMessage">
                  </form-write-group-label-input>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col cols="10" offset="2" class="d-flex">
                  <div class="custom-control custom-checkbox">
                    <input id="checkbox-rgpd" type="checkbox" v-model="rgpd" class="custom-control-input" :value="1">
                    <label class="custom-control-label" @click="clickedRgpd">
                      <span>{{ $t('loginPage.accept_rgpd') }}</span><span class="text-link font-weight-normal pl-2" @click="getUri(links.rgpd_mandatory)">{{ $t('common.read') }}</span>
                    </label>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="8" offset="2" class="d-flex">
                  <div class="custom-control custom-checkbox">
                    <input id="checkbox-terms-conditions" type="checkbox" v-model="termsConditions" class="custom-control-input" :value="1" :unchecked-value="0">
                    <label class="custom-control-label" @click="clickedTerms">
                      <span>{{ $t('loginPage.accept_cgu') }}</span><span class="text-link font-weight-normal pl-2" @click="getUri(links.conditions_mandatory)">{{ $t('common.read') }}</span>
                    </label>
                  </div>

                </b-col>
              </b-row>
            </div>
            <div @keyup.enter="registerUser()" v-if="mode === 'register'">
              <b-row>
                <b-col cols="8" offset="2" class="form-group">
                  <form-write-group-label-input v-model="credentials.Login" id="Login"
                    inputType="text"
                    :inputLabel="$t('common.eml_adrs')"
                    inputClass="inputLogin"
                    :specificErrorIndicator="credentials.LoginError"
                    :specificMessage="credentials.LoginErrorMessage">
                  </form-write-group-label-input>
                </b-col>
              </b-row>
              <!-- Password -->
              <b-row>
                <b-col cols="8" offset="2" class="form-group">
                  <div>
                    <label for="password">{{ $t('common.pwd') }}</label>
                    <div class="d-flex">
                      <input v-model="credentials.Password"
                        id="password"
                        class="form-control inputAccordionForm inputLogin h-30px"
                        :class="[credentials.PasswordError ? 'errorBorder' : '']"
                        :type="credentials.PasswordFieldType">
                      </input>
                      <i class="icon icon-password mt-2 pt-1"
                        :class="[isPasswordFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                        @click="togglePasswordVisibility">
                      </i>
                    </div>
                    <div v-if="credentials.PasswordError" class="text-danger">
                      {{ credentials.PasswordErrorMessage }}
                    </div>
                  </div>
                </b-col>
              </b-row>
              <!-- Password Confirmation -->
              <b-row>
                <b-col cols="8" offset="2" class="form-group">
                  <div>
                    <label for="password">{{ $t('common.conf_pwd') }}</label>
                    <div class="d-flex">
                      <input v-model="credentials.PasswordRepeat"
                        id="password"
                        class="form-control inputAccordionForm inputLogin h-30px"
                        :class="[credentials.PasswordRepeatError ? 'errorBorder' : '']"
                        :type="credentials.PasswordRepeatFieldType">
                      </input>
                      <i class="icon icon-password mt-2 pt-1"
                        :class="[isPasswordRepeatFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                        @click="togglePasswordRepeatVisibility">
                      </i>
                    </div>
                    <div v-if="credentials.PasswordRepeatError" class="text-danger">
                      {{ credentials.PasswordRepeatErrorMessage }}
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>

            <div @keyup.enter="registerUser()" v-if="mode === 'totp'">
              <b-row>
                <b-col cols="8" offset="2" class="form-group">
                  <form-write-group-label-input v-model="credentials.Login" id="Login" disabled
                    inputType="text"
                    :inputLabel="$t('common.eml_adrs')"
                    inputClass="inputLogin"
                    :specificErrorIndicator="credentials.LoginError"
                    :specificMessage="credentials.LoginErrorMessage">
                  </form-write-group-label-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="8" offset="3">
                  <div v-if="qrCodeDataUrl">
                    <img :src="qrCodeDataUrl" alt="QR Code"/>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="8" offset="2" class="form-group">
                  <div>
                    <label for="token TOTP">{{ $t('common.totp') }}</label>
                    <div class="d-flex">
                      <input v-model="credentials.Totp"
                        id="password"
                        class="form-control inputAccordionForm inputLogin h-30px"
                        :class="[credentials.TotpError ? 'errorBorder' : '']"
                        :type="credentials.PasswordFieldType">
                      </input>
                      <i class="icon icon-password mt-2 pt-1"
                        :class="[isPasswordFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                        @click="togglePasswordVisibility">
                      </i>
                    </div>
                    <div v-if="credentials.TotpError" class="text-danger">
                      {{ credentials.PasswordErrorMessage }}
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>

            <div v-else-if="mode === 'confirmEmailSent'">
              <span>{{$t('loginPage.email_confirmation_mail_sent')}}</span>
            </div>

            <b-row class="loginButtons" v-if="['confirmEmail', 'register', 'totp'].includes(mode)">
              <b-col cols="8" offset="2">
                <b-button variant="primary" size="lg" id="submit-btn"
                  @click="registerUser()">
                  {{ $t('loginPage.create_account') }}
                </b-button>
              </b-col>
            </b-row>
            <footer class="pt-3 pb-1">
              <b-row>
                <b-col class="xs-12 text-center">
                  <b-col class="d-flex justify-content-center align-items-center">
                    <img class="logoStreammind" alt="Streammind" :src="logoStreammind"></img>
                    <span> {{ $t('common.copyright')}}</span>&nbsp;
                    <span>{{ version }}</span>
                  </b-col>
                </b-col>
              </b-row>
            </footer>
          </div>
        </div>
      </b-row>
    </div>
  </f7-page>
</template>

<script>

import conf from '../../config/config.dev.js'

import _ from 'lodash'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import Spinner from '@/components/common/spinner'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

import designToolBox from '@/design/designToolBox.json'
import designDealprudence from '@/design/designDealprudence.json'

const flagTOOLBOX = conf.visual === 'TOOLBOX'

const design = flagTOOLBOX ? designToolBox : designDealprudence

import StreammindImageNoir from './../../assets/static/images/streammind-text-seul.png'
import StreammindImageBlanc from './../../assets/static/images/streammind-text-seul-blanc.png'
const StreammindImage = flagTOOLBOX ? StreammindImageNoir : StreammindImageNoir
import FlagFRImage from './../../assets/static/images/fr.png'
import FlagENImage from './../../assets/static/images/gb.png'
import FlagDEImage from './../../assets/static/images/de.png'
import FlagITImage from './../../assets/static/images/it.png'
import FlagESImage from './../../assets/static/images/es.png'
import FlagPTImage from './../../assets/static/images/pt.png'
import QRCode from 'qrcode'

export default {
  name: 'RegisterWithToken',
  props: {
    // marche pas en route, on les récup dans l'URL du coup
    // token: {
    //   type: String,
    //   default: ''
    // },
    // email: {
    //   type: String,
    //   default: '-1'
    // }
  },
  components: {
    'form-write-group-label-input': formWriteGroupLabelInput,
    'spinner': Spinner
  },
  computed: {
    labelLanguage () {
      let lang = this.language
      let langOpt = this.langOptions.filter(elem => elem.value.toLowerCase() === lang.toLowerCase())
      let label = this.language
      if (langOpt.length) {
        label = langOpt[0].value
      }
      return label
    },
    imgVarsLong () {
      return this.design.headbandLogoLong
    },
    isPasswordFieldHidden () {
      return this.credentials.PasswordFieldType === 'password'
    },
    isPasswordRepeatFieldHidden () {
      return this.credentials.PasswordRepeatFieldType === 'password'
    }
  },
  data: () => {
    return {
      design: design.login,
      confirmEmail: '',
      uri: '',
      links: conf.rgpd,
      credentials: {
        Login: '',
        LoginError: false,
        LoginErrorMessage: '',
        Token: '',
        Totp: "",
        TokenError: false,
        TokenErrorMessage: '',
        Password: '',
        PasswordError: false,
        PasswordErrorMessage: '',
        TotpError: false,
        TotpErrorMessage: '',
        PasswordFieldType: 'password',
        PasswordRepeat: '',
        PasswordRepeatError: false,
        PasswordRepeatErrorMessage: '',
        PasswordRepeatFieldType: 'password'
      },
      email: '-1',
      flagTOOLBOX: conf.visual === 'TOOLBOX',
      idAccount: '',
      langOptions: [],
      language: '',
      logoFlagFR: FlagFRImage,
      logoFlagEN: FlagENImage,
      logoFlagDE: FlagDEImage,
      logoFlagIT: FlagITImage,
      logoFlagES: FlagESImage,
      logoFlagPT: FlagPTImage,
      logoStreammind: StreammindImage,
      mode: '',
      rgpd: 0,
      termsConditions: 0,
      token: '',
      version:'',
      qrCodeDataUrl: '',
      qrData: ''
    }
  },
  created () {
    this.language = this.$i18n.locale.toUpperCase()
    this.langOptions = [
      { value: 'EN', text: this.$t('lang.english')},
      { value: 'FR', text: this.$t('lang.french')}
    ]
    let route = this.$f7.mainView.url.split('/')
    if (route.length >= 4) {
      this.token = route[2]
      this.email = route[3]
    }
    if (this.email !== '-1' && this.token) {
      this.mode = 'register'
      this.credentials.Token = this.token
      this.credentials.Login = this.email
    } else {
      this.mode = 'confirmEmail'
    }
  },
  mounted () {
    if (this.$engine.auth.user.get().identifier !== '' && !location.href.includes('OTP')) {
      this.$$('.navbar').removeClass('deleteNavBar')
      this.$bus.$emit('login', true)
      loadPage(this, {url: this.flagTOOLBOX ? '/homecarrousel/' : '/home/'})
    }
  },
  methods: {
    click () {
      let that = this
      getUri(uri)
    },

    getUri (uri) {
      let that = this
      fetch(uri, {method: 'HEAD'})
      .then(response => {
        const link = document.createElement('a');
        link.href = uri;
        link.download = ''; // Laisser vide pour que le nom d'origine soit utilisé
        link.target = '_blank';
        link.click();
      })
      .catch(err => {
        that.$f7.alert(that.$i18n.t('faq.download_error_desc'), that.$i18n.t('faq.download_error'))
        console.log('err', err)
      })
    },
    clickedRgpd ($event) {
      this.rgpd = this.rgpd === 1 ? 0 : 1
    },
    clickedTerms ($event) {
      this.termsConditions = this.termsConditions === 1 ? 0 : 1
    },
    generateQRCode() {
      QRCode.toDataURL(this.qrData)
        .then(url => {
          this.qrCodeDataUrl = url
        })
        .catch(err => {
          console.error('Erreur lors de la génération du QR Code :', err)
        })
    },
    languageCountry (language) {
      this.language = language
      if (language === 'EN') {
        this.$i18n.locale = 'en'
      }
      else if (language === 'GB') {
        this.$i18n.locale = 'gb'
      }
      else if (language === 'ES') {
        this.$i18n.locale = 'es'
      }
      else if (language === 'IT') {
        this.$i18n.locale = 'it'
      }
      else if (language === 'DE') {
        this.$i18n.locale = 'de'
      }
      else if (language === 'PT') {
        this.$i18n.locale = 'pt'
      } else {
        this.$i18n.locale = 'fr'
      }
      this.langOptions = [
        { value: 'EN', text: this.$t('lang.english')},
        { value: 'FR', text: this.$t('lang.french')}
      ]
    },
    showRGPD ($event) {
      $event.stopPropagation()
      this.$bus.emit('popup-rgpd')
    },
    showTermsConditions ($event) {
      $event.stopPropagation()
      this.$bus.emit('popup-terms-conditions')
    },
    togglePasswordRepeatVisibility () {
      this.credentials.PasswordRepeatFieldType = (this.credentials.PasswordRepeatFieldType === 'text' ? 'password' : 'text')
    },
    togglePasswordVisibility () {
      this.credentials.PasswordFieldType = (this.credentials.PasswordFieldType === 'text' ? 'password' : 'text')
      this.credentials = _.cloneDeep(this.credentials)
    },
    validateForm () {
      let result = true
      if (!this.credentials.Login) {
        this.credentials.LoginError = true
        this.credentials.LoginErrorMessage = this.$i18n.t('errors.eml_adrs_mandatory')
        result = false
      } else if (!(/^.+@.+\..+$/.test(this.credentials.Login)) && this.credentials.Login.length < 50) {
        this.credentials.LoginError = true
        this.credentials.LoginErrorMessage = this.$i18n.t('errors.eml_adrs_format')
        result = false
      } else {
        this.credentials.LoginError = false
        this.credentials.LoginErrorMessage = ''
      }
      if (this.mode === 'confirmEmail') {
        // control token
        if (!this.credentials.Token) {
          result = false
          this.credentials.TokenError = true
          this.credentials.TokenErrorMessage = this.$i18n.t('errors.token_mandatory')
        } else {
          this.credentials.TokenError = false
          this.credentials.TokenErrorMessage = ''
        }
        if (!this.rgpd) {
          result = false
          this.$f7.alert('',this.$i18n.t('errors.rgpd_mandatory'))
          return false
        }
        if (!this.termsConditions) {
          result = false
          this.$f7.alert('',this.$i18n.t('errors.terms_conditions_mandatory'))
          return false
        }
      } else if (this.mode === 'register') {
        // control password et confirmPassword
        if (!this.credentials.Password) {
          result = false
          this.credentials.PasswordError = true
          this.credentials.PasswordErrorMessage = this.$i18n.t('errors.password_wrong_format')
        }
        // on ne check pas le format pour le moment
        // else if (!this.credentials.Password) {
          // result = false
          // this.credentials.PasswordError = true
          // this.credentials.PasswordErrorMessage = this.$i18n.t('errors.password_mandatory')
        // }
        else {
          this.credentials.PasswordError = false
          this.credentials.PasswordErrorMessage = ''
        }

        if (!this.credentials.PasswordRepeat) {
          result = false
          this.credentials.PasswordRepeatError = true
          this.credentials.PasswordRepeatErrorMessage = this.$i18n.t('errors.password_repeat_mandatory')
        }
        else if (this.credentials.PasswordRepeat !== this.credentials.Password) {
          result = false
          this.credentials.PasswordRepeatError = true
          this.credentials.PasswordRepeatErrorMessage = this.$i18n.t('errors.passwords_not_matching')
        } else {
          this.credentials.PasswordRepeatError = false
          this.credentials.PasswordRepeatErrorMessage = ''
        }
      }
      return result
    },
    registerUser () {
      if (!this.validateForm()) {
        return
      }

      let that = this
      if (this.mode === 'confirmEmail') {
        this.$engine.auth.registerToken({
          email: this.credentials.Login,
          token: this.credentials.Token,
          lang: that.language
        })
        .then(resp => {
          that.mode = 'confirmEmailSent'
        })
        .catch(error => {
          let errMsgTitle = ''
          let errMsgDesc = ''
          if (error && error.response && error.response.data && error.response.data.error) {
            if (('errors._specific.title.' + error.response.data.error) !== that.$t('errors._specific.title.' + error.response.data.error)) {
              errMsgTitle = that.$t('errors._specific.title.' + error.response.data.error)
              errMsgDesc = that.$t('errors._specific.description.' + error.response.data.error)
            }
          }
          if (errMsgTitle && errMsgDesc) {
            that.$f7.alert(errMsgDesc, errMsgTitle)
          } else {
            errorMessageAlert(error, that)
          }
        })
      } else if (this.mode === 'register') {
        this.$engine.auth.registerToken({
          email: this.credentials.Login,
          password: this.credentials.Password,
          token: this.credentials.Token,
          lang: that.language
        })
        .then(resp => {
          this.qrData = resp.data.totpUrl
          this.generateQRCode()
          that.mode = 'totp'
        })
        .catch(error => {
          that.$f7.hidePreloader()
          let errMsgTitle = ''
          let errMsgDesc = ''
          if (error && error.response && error.response.data && error.response.data.error) {
            if (('errors._specific.title.' + error.response.data.error) !== that.$t('errors._specific.title.' + error.response.data.error)) {
              errMsgTitle = that.$t('errors._specific.title.' + error.response.data.error)
              errMsgDesc = that.$t('errors._specific.description.' + error.response.data.error)
            }
          }
          if (errMsgTitle && errMsgDesc) {
            that.$f7.alert(errMsgDesc, errMsgTitle)
          } else {
            errorMessageAlert(error, that)
          }
        })
      } else if (this.mode === 'totp') {
        this.$engine.auth.registerToken({
          email: this.credentials.Login,
          totp: this.credentials.Totp,
          token: this.credentials.Token,
          lang: that.language
        })
        .then(resp => {
          that.$f7.showPreloader(this.$t('registerPage.rgstrtn_done'))
          that.$engine.auth.login({
            ConnectBy: 'lpc',
            WithPassword: '1',
            Totp: this.credentials.Totp,
            Login: that.credentials.Login,
            Password: that.credentials.Password
          })
          .then(resp => {
            that.$engine.user.connectBy = 'login-password-capi'
            that.$bus.emit('login', true)
            that.$bus.emit('service:change', this.defaultService)
            that.$bus.emit('refresh-cache-menu')
            that.$f7.hidePreloader()
            that.$$('.panel-overlay').css('z-index', '')
            that.$$('.deleteNavBar').removeClass('deleteNavBar')
            loadPage(that, {url: that.flagTOOLBOX ? '/homecarrousel/' : '/home/'})
          })
          .catch(err => {
            that.$f7.hidePreloader()
            errorMessageAlert(err, that)
          })
        })
        .catch(error => {
          that.$f7.hidePreloader()
          let errMsgTitle = ''
          let errMsgDesc = ''
          if (error && error.response && error.response.data && error.response.data.error) {
            if (('errors._specific.title.' + error.response.data.error) !== that.$t('errors._specific.title.' + error.response.data.error)) {
              errMsgTitle = that.$t('errors._specific.title.' + error.response.data.error)
              errMsgDesc = that.$t('errors._specific.description.' + error.response.data.error)
            }
          }
          if (errMsgTitle && errMsgDesc) {
            that.$f7.alert(errMsgDesc, errMsgTitle)
          } else {
            errorMessageAlert(error, that)
          }
        })
      }
    }
  }
}
</script>
